<template>
  <div v-if="userEditVm.user">
    <dara-row>
      <dara-col>
        <fieldset class="form-group">
          <label for="preferences" class="w-100 mb-1">{{ $t('articles-notifications') }}</label>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.article_user"
                type="checkbox"
                class="form-check-input"
                value="article_user"
                :disabled="userEditVm.user.preference.new_article">
              {{ $t('new-articles-from-followed-users') }}
              <small
                v-if="userEditVm.user.preference.new_article"
                class="text-muted">
                ({{ $t('disabled') }})
              </small>
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.new_article"
                type="checkbox"
                class="form-check-input"
                value="new_article"
                :disabled="userEditVm.user.preference.article_user">
              {{ $t('new-articles') }}
              <small
                v-if="userEditVm.user.preference.article_user"
                class="text-muted">
                ({{ $t('disabled') }})
              </small>
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.article_update"
                type="checkbox"
                class="form-check-input"
                value="article_update">
              {{ $t('updated-articles') }}
            </label>
          </div>
        </fieldset>

        <fieldset class="form-group mt-3">
          <label for="preferences" class="w-100 mt-2 mb-1">{{ $t('questions-notifications') }}</label>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.question_user"
                type="checkbox"
                class="form-check-input"
                value="question_user"
                :disabled="userEditVm.user.preference.new_question">
              {{ $t('new-questions-from-followed-users') }}
              <small
                v-if="userEditVm.user.preference.new_question"
                class="text-muted">
                ({{ $t('disabled') }})
              </small>
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.new_question"
                type="checkbox"
                class="form-check-input"
                value="new_question"
                :disabled="userEditVm.user.preference.question_user">
              {{ $t('new-questions') }}
              <small
                v-if="userEditVm.user.preference.question_user"
                class="text-muted">
                ({{ $t('disabled') }})
              </small>
            </label>
          </div>
        </fieldset>

        <fieldset class="form-group mt-3">
          <label for="preferences" class="w-100 mt-2 mb-1">{{ $t('answers-notifications') }}</label>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.new_answer"
                type="checkbox"
                class="form-check-input"
                value="new_answer">
              {{ $t('new-answers') }}
            </label>
          </div>
        </fieldset>

        <fieldset class="form-group mt-3">
          <label for="preferences" class="w-100 mt-2 mb-1">{{ $t('tracks-notifications') }}</label>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.new_track"
                type="checkbox"
                class="form-check-input"
                value="new_track">
              {{ $t('new-tracks') }}
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.track_update"
                type="checkbox"
                class="form-check-input"
                value="track_update"
                :disabled="userEditVm.user.preference.followed_track_update">
              {{ $t('updated-tracks') }}
              <small
                v-if="userEditVm.user.preference.followed_track_update"
                class="text-muted">
                ({{ $t('disabled') }})
              </small>
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.followed_track_update"
                type="checkbox"
                class="form-check-input"
                value="followed_track_update"
                :disabled="userEditVm.user.preference.track_update">
              {{ $t('followed-tracks-updated') }}
              <small
                v-if="userEditVm.user.preference.track_update"
                class="text-muted">
                ({{ $t('disabled') }})
              </small>
            </label>
          </div>
        </fieldset>

        <fieldset class="form-group mt-3">
          <label for="preferences" class="w-100 mt-2 mb-1">{{ $t('tags-notifications') }}</label>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.article_tag"
                type="checkbox"
                class="form-check-input"
                value="article_tag">
              {{ $t('new-or-updated-articles-with-followed-tags') }}
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.question_tag"
                type="checkbox"
                class="form-check-input"
                value="question_tag">
              {{ $t('new-questions-with-followed-tags') }}
            </label>
          </div>
        </fieldset>
      </dara-col>
    </dara-row>

    <dara-row class="mt-4">
      <dara-col>
        <dara-header size="md">{{ $t('email-notifications') }}</dara-header>
        <fieldset class="form-group mt-3">
          <div class="form-check">
            <label class="form-check-label">
              <input
                v-model="userEditVm.user.preference.email_notification"
                type="checkbox"
                class="form-check-input"
                value="email_notification">
              {{ $t('receive-flagged-notifications-by-email') }}
            </label>
          </div>
          <!-- <div class="form-check">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                value="recommended_articles"
                disabled>
              {{ $t('receive-featured-articles-by-email') }} <small class="text-muted">({{ $t('soon') }})</small>
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                value="recommended_questions"
                disabled>
              {{ $t('receive-featured-questions-by-email') }} <small class="text-muted">({{ $t('soon') }})</small>
            </label>
          </div> -->
        </fieldset>
      </dara-col>
    </dara-row>
  </div>
</template>

<script>

export default {
  name: 'DaraSettingPreferencesForm',
  inject: ['userEditVm'],
};
</script>
